import { apiFetch } from './client';

export const getWeeklyPriorities = (params = {}) =>
  apiFetch(`/api/weekly-priorities?${new URLSearchParams(params)}`);

export const generateWeeklyPriority = () =>
  apiFetch('/api/weekly-priorities/generate', { method: 'POST', body: '{}' });
